import { render, staticRenderFns } from "./ResultFastener.vue?vue&type=template&id=bcde43b6&scoped=true&"
import script from "./ResultFastener.vue?vue&type=script&lang=js&"
export * from "./ResultFastener.vue?vue&type=script&lang=js&"
import style0 from "./ResultFastener.vue?vue&type=style&index=0&id=bcde43b6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcde43b6",
  null
  
)

export default component.exports